import { SurveysApiFactory } from '@front-app/api-generated/learning-management-api';
import { createTRApi } from '@front-app/services/api';

export const surveysApi = SurveysApiFactory(undefined, process.env.VUE_APP_API_SURVEY_BASE_URL, createTRApi(''));
